<header class="flex flex-col justify-center w-full max-w-7xl mx-auto text-3xl bg-white shadow-sm">
  <nav class="hidden sm:flex flex-row justify-between p-4">
    <div class="flex flex-row items-center">
      <a href="/" data-testid="logo">
        <img src="assets/navigandi-logo.png" alt="Logo da empresa" class="w-20 h-20" />
      </a>
    </div>
    <div class="flex flex-row items-center">
      <ul class="flex flex-row items-center" data-testid="main-menu">
        <li class="mx-2 text-blue-950 text-xl hover:text-blue-800"><a href="#home">Início</a></li>
        <li class="mx-2 text-blue-950 text-xl hover:text-blue-800"><a href="#about">Sobre</a></li>
        <li class="mx-2 text-blue-950 text-xl hover:text-blue-800">
          <a href="#services">Serviços</a>
        </li>
        <li class="mx-2 text-blue-950 text-xl hover:text-blue-800">
          <a href="#products">Produtos</a>
        </li>
        <li class="mx-2 text-blue-950 text-xl hover:text-blue-800">
          <a href="/auth/signin" title="Entrar" data-testid="login-button">Entrar</a>
        </li>
        <li
          class="mx-2 text-white text-xl bg-yellow-400 hover:bg-yellow-500 px-4 py-2 rounded-full"
        >
          <a href="#contact">Contato</a>
        </li>
      </ul>
    </div>
  </nav>

  <nav
    class="sm:hidden flex flex-col justify-between items-center border-b bg-white border-blue-900"
  >
    <div class="flex flex-row-reverse justify-between w-full items-center p-4">
      <button mat-icon-button aria-label="Menu icon" class="text-blue-950" (click)="toggleMenu()">
        <mat-icon *ngIf="isCollapsed">close</mat-icon><mat-icon *ngIf="!isCollapsed">menu</mat-icon>
      </button>
      <div class="flex flex-row items-center justify-start ml-2 w-full">
        <a href="/">
          <img src="assets/navigandi-logo.png" alt="Logo da empresa" class="w-14 h-14" />
        </a>
      </div>
    </div>
    <div *ngIf="isCollapsed" class="flex flex-row items-center w-full bg-slate-100">
      <ul class="grid grid-cols-1 gap-2 justify-start items-start w-full p-4">
        <li (click)="toggleMenu()" class="flex w-full">
          <a href="#home" class="text-slate-950 text-xl p-2 w-full bg-white border border-slate-300"
            >Início</a
          >
        </li>
        <li (click)="toggleMenu()" class="flex w-full">
          <a
            href="#about"
            class="text-slate-950 text-xl p-2 w-full bg-white border border-slate-300"
            >Sobre</a
          >
        </li>
        <li (click)="toggleMenu()" class="flex w-full">
          <a
            href="#services"
            class="text-slate-950 text-xl p-2 w-full bg-white border border-slate-300"
            >Serviços</a
          >
        </li>
        <li (click)="toggleMenu()" class="flex w-full">
          <a
            href="#products"
            class="text-slate-950 text-xl p-2 w-full bg-white border border-slate-300"
            >Produtos</a
          >
        </li>
        <li (click)="toggleMenu()" class="flex w-full">
          <a
            href="/auth/signin"
            class="text-slate-950 text-xl p-2 w-full bg-white border border-slate-300"
            title="Entrar"
            >Entrar</a
          >
        </li>
        <li (click)="toggleMenu()" class="flex w-full">
          <a
            href="#contact"
            class="text-slate-950 text-xl p-2 w-full bg-white border border-slate-300"
            >Contato</a
          >
        </li>
      </ul>
    </div>
  </nav>
</header>
